import { ElementRef } from '@angular/core';

/**
 * Finds the first invalid form control within the given container element
 * and scrolls it into view, setting focus on it.
 *
 * @param elementRef The container element (usually the component's host element)
 */
export function scrollToFirstInvalidControl(elementRef: ElementRef | HTMLElement): void {
    const element = elementRef instanceof ElementRef ? elementRef.nativeElement : elementRef;
    if (!element) return;

    // Wait for change detection to update classes (setTimeout usually helps if called immediately after status change)
    setTimeout(() => {
        // Select standard Angular invalid classes or Bootstrap's is-invalid
        const firstInvalid = element.querySelector('.ng-invalid.ng-touched, .is-invalid, .ng-invalid.form-control');
        if (firstInvalid) {
            firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            (firstInvalid as HTMLElement).focus();
        }
    }, 100);
}
